import axiosClient from './setup/axiosClient';

export const PaymentInfoApis = {
  getPaymentInfoReport: async (params: any): Promise<any> => {
    return axiosClient.get('/payment/web/payment-info-report', { params });
  },
  exportPaymentInfoExcel: async (params: any): Promise<any> => {
    return axiosClient.get('/payment/web/payment-info-report/export-excel', {
      params,
      responseType: 'blob',
    });
  },
};
